<template>
	<div name="hrms14x-popup-route-no" id="hrms14x-popup-route-no" class="modal fade modal-full-width" role="dialog">
		<div class="modal-dialog ">
	    <div class="modal-content">
	      <div class="modal-header header-popup">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title">{{ labels['HRMS14XC4']['10'] }}</h4>
        </div>

        <div class="modal-body detail detail-responsive">
        	<div class="detail detail-responsive">
        		<form class="form-horizontal">
		          <div class="form-group margin-b-5">
		            <label class="col-md-4 control-label">{{ labels['HRMS14XC4']['20'] }}</label>
		            <div class="col-md-4">
		              <div class="form-control readonly-field-color">{{ indexSelected.codempid }} - {{ indexSelected.desc_codempid }}</div>
		            </div>
		          </div>
		        </form>
        		<form class="form-horizontal">
		          <div class="form-group margin-b-5">
		            <label class="col-md-4 control-label">{{ labels['HRMS14XC4']['30'] }}</label>
		            <div class="col-md-4">
		              <div class="form-control readonly-field-color">{{ indexSelected.routeno }} - {{ indexSelected.desc_routeno }}</div>
		            </div>
		          </div>
		        </form>
						<hrms-table :columns="columns" :data="data" :indexDisp="false" />	    
					</div>		
		
        </div>

	    </div>
    </div>
	</div>
</template>

<script>
export default {
  name: 'hrms14x-popup-route-no',
  props: [ 'labels', 'data', 'columns', 'indexSelected' ]
}
</script>





// WEBPACK FOOTER //
// popupRouteNo.vue?a0badb72